import { BloombergEpisodesPageContextType } from "./types";

export const defaultBloombergEpisodesPageContextValue: BloombergEpisodesPageContextType = {
  data: undefined,
  isLoadingData: true,
  updateContext: () => {},
};
